import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { LocalizationTexts, OptimusTextKey, TranslationOptions } from '@optimus-web/localization';
import { FrameworkTextKey as TextKey } from './FrameworkTextKey';

export const useDefaultLocalizationTexts = (): LocalizationTexts => {
    const intl = useIntl();

    return useMemo(
        () => ({
            [OptimusTextKey.Cancel]: intl.formatMessage({ id: TextKey.Cancel }),
            [OptimusTextKey.ChartEmptyDefaultMessage]: intl.formatMessage({ id: TextKey.ChartEmptyDefaultMessage }),
            [OptimusTextKey.ChartErrorDefaultMessage]: intl.formatMessage({ id: TextKey.ChartErrorDefaultMessage }),
            [OptimusTextKey.ChooseFile]: intl.formatMessage({ id: TextKey.ChooseFile }),
            [OptimusTextKey.ClearSelection]: intl.formatMessage({ id: TextKey.ClearSelection }),
            [OptimusTextKey.Custom]: intl.formatMessage({ id: TextKey.GeneralCustom }),
            [OptimusTextKey.DeselectAll]: intl.formatMessage({ id: TextKey.DeselectAll }),
            [OptimusTextKey.DialogedDatePickerCancel]: intl.formatMessage({ id: TextKey.Cancel }),
            [OptimusTextKey.DropzoneFileLimitOverReachedError]: intl.formatMessage({
                id: TextKey.DropzoneFileLimitOverReachedError,
            }),
            [OptimusTextKey.DropzoneFileLimitReached]: intl.formatMessage({ id: TextKey.DropzoneFileLimitReached }),
            [OptimusTextKey.Help]: intl.formatMessage({ id: TextKey.Help }),
            [OptimusTextKey.LastMonth]: intl.formatMessage({ id: TextKey.LastMonth }),
            [OptimusTextKey.LastQuarter]: intl.formatMessage({ id: TextKey.LastQuarter }),
            [OptimusTextKey.LastWeek]: intl.formatMessage({ id: TextKey.LastWeek }),
            [OptimusTextKey.LastYear]: intl.formatMessage({ id: TextKey.LastYear }),
            [OptimusTextKey.Loading]: intl.formatMessage({ id: TextKey.Loading }),
            [OptimusTextKey.NextMonth]: intl.formatMessage({ id: TextKey.NextMonth }),
            [OptimusTextKey.NextQuarter]: intl.formatMessage({ id: TextKey.NextQuarter }),
            [OptimusTextKey.NextWeek]: intl.formatMessage({ id: TextKey.NextWeek }),
            [OptimusTextKey.NextYear]: intl.formatMessage({ id: TextKey.NextYear }),
            [OptimusTextKey.NoResultsForSearch]: intl.formatMessage({ id: TextKey.NoResultsForSearch }),
            [OptimusTextKey.Of]: intl.formatMessage({ id: TextKey.Of }),
            [OptimusTextKey.Ok]: intl.formatMessage({ id: TextKey.Ok }),
            [OptimusTextKey.Optional]: intl.formatMessage({ id: TextKey.Optional }),
            [OptimusTextKey.Or]: intl.formatMessage({ id: TextKey.Or }),
            [OptimusTextKey.PreviousMonth]: intl.formatMessage({ id: TextKey.PreviousMonth }),
            [OptimusTextKey.Remove]: intl.formatMessage({ id: TextKey.Remove }),
            [OptimusTextKey.SelectAll]: intl.formatMessage({ id: TextKey.SelectAll }),
            [OptimusTextKey.SelectDate]: intl.formatMessage({ id: TextKey.SelectDate }),
            [OptimusTextKey.SelectEmptyMessage]: intl.formatMessage({ id: TextKey.NoResultsForSearch }),
            [OptimusTextKey.TableClearFilters]: intl.formatMessage({ id: TextKey.ClearFilters }),
            [OptimusTextKey.TableEmptyStatePrimary]: intl.formatMessage({ id: TextKey.NoDataAvailable }),
            [OptimusTextKey.TableFilterBySearch]: intl.formatMessage({ id: TextKey.FilterBySearch }),
            [OptimusTextKey.TableFilterContains]: intl.formatMessage({ id: TextKey.Contains }),
            [OptimusTextKey.TableFilterGreaterThan]: intl.formatMessage({ id: TextKey.GreaterThan }),
            [OptimusTextKey.TableHeaderSearch]: intl.formatMessage({ id: TextKey.Search }),
            [OptimusTextKey.TablePaginationItemsCount]: ({ items }: TranslationOptions = {}) =>
                intl.formatMessage({ id: items === 1 ? TextKey.ItemSingular : TextKey.ItemPlural }, { items }),
            [OptimusTextKey.TablePaginationSizeItemsCount]: ({ items }: TranslationOptions = {}) =>
                intl.formatMessage({ id: TextKey.PaginationItems }, { items }),
            [OptimusTextKey.TablePaginationShow]: intl.formatMessage({ id: TextKey.Show }),
            [OptimusTextKey.TableSortAscending]: intl.formatMessage({ id: TextKey.SortAscending }),
            [OptimusTextKey.TableSortDescending]: intl.formatMessage({ id: TextKey.SortDescending }),
            [OptimusTextKey.ThisMonth]: intl.formatMessage({ id: TextKey.ThisMonth }),
            [OptimusTextKey.ThisQuarter]: intl.formatMessage({ id: TextKey.ThisQuarter }),
            [OptimusTextKey.ThisWeek]: intl.formatMessage({ id: TextKey.ThisWeek }),
            [OptimusTextKey.ThisYear]: intl.formatMessage({ id: TextKey.ThisYear }),
            [OptimusTextKey.Today]: intl.formatMessage({ id: TextKey.Today }),
            [OptimusTextKey.Tomorrow]: intl.formatMessage({ id: TextKey.Tomorrow }),
            [OptimusTextKey.Yesterday]: intl.formatMessage({ id: TextKey.Yesterday }),
        }),
        [intl]
    );
};
